import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const wutBadge: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_WutBadge_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'WutBadgeRole',
      bindings: [
        {
          title: 'dsgnsys_WutBadge_dataBinding_text_label',
          prop: 'text',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.richText,
            FieldType.email,
          ],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
